import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "@/redux/store";
import { useSelector } from "react-redux";

import { Button, CardItem } from "@/components";
import { getCardSelector } from "@/redux/profile/cards/selectors";
import { fetchGetCards } from "@/redux/profile/cards/asyncActions";
import { resetCardsState, setCardid } from "@/redux/profile/cards/slice";

import { useCurrentWidth } from "@/hooks";
import { MediaBreakPoints } from "@/resources/constants";

import PlusIcon from "@/assets/icons/plus.svg";
import styles from "./Cards.module.scss";
import { CardsSkeleton } from "./CardsSkeleton";
import arrowIcon from "@/assets/icons/arrowCalendarLeft.svg";

export const Cards: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const windowWidth = useCurrentWidth();
  const isMobile = windowWidth <= MediaBreakPoints.DESKTOP;

  const { cards, isLoading } = useSelector(getCardSelector);

  useEffect(() => {
    dispatch(fetchGetCards());
    return () => {
      dispatch(resetCardsState());
    };
  }, [dispatch]);

  const handlePaymentClick = async () => {
    try {
      navigate("/profile/add-card");
    } catch (error) {
      console.error("Ошибка при получении токена для оплаты:", error);
    }
  };

  const handleBack = () => {
    navigate('/profile');
  };

  const handleSelectItem = (id: number) => {
    dispatch(setCardid(id));
  };

  if (isLoading) {
    return (
      <div className={styles.wrapper}>
        {isMobile && (
          <div className={styles.headerMobile}>
            <button className={styles.logoutButton} onClick={handleBack}>
              <img src={arrowIcon} alt="back" />
            </button>
            <h2 className={styles.title}>
              Привязанные карты
            </h2>
          </div>
        )}
        {!isMobile && (
          <h2 className={styles.title}>
            Привязанные карты
          </h2>
        )}
        <CardsSkeleton />
      </div>
    );
  }

  return (
    <div className={styles.wrapper}>
      {isMobile && (
        <div className={styles.headerMobile}>
          <button className={styles.logoutButton} onClick={handleBack}>
            <img src={arrowIcon} alt="back" />
          </button>
          <h2 className={styles.title}>
            Привязанные карты
          </h2>
        </div>
      )}
      {!isMobile && (
        <h2 className={styles.title}>
          Привязанные карты
        </h2>
      )}
      <div className={styles.item}>
        {!!cards &&
          cards.length > 0 &&
          cards.map((item) => (
            <CardItem
              data={item}
              key={item.id}
              dataType="cardItem"
              onPage="profile"
              selectFunc={handleSelectItem}
            />
          ))}

        <Button
          newStyles={styles.item_plusItem}
          onClickFunc={handlePaymentClick}
        >
          <img src={PlusIcon} alt="plus" />
          <span>
            Добавить карту
          </span>
        </Button>
      </div>
    </div>
  );
};
